import { useCallback, useMemo } from 'react'
import { UsersRound } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchMassRegistration, SEC_STR as S, type MassRegRow } from './securityMoreApi'

/**
 * A18.15 — Атака массовой регистрации. Bursts of sign-ups from one IP/pattern.
 * Fail-soft empty until `/admin/security/mass-registration` ships.
 */
export function MassRegistrationScreen() {
  const columns = useMemo<AdminColumn<MassRegRow>[]>(
    () => [
      { key: 'window', header: S.window, type: 'text', width: 160 },
      { key: 'ip', header: S.ip, type: 'text', width: 150 },
      { key: 'count', header: S.count, type: 'number', width: 110 },
      { key: 'pattern', header: S.pattern, type: 'text', minWidth: 200 },
      {
        key: 'status',
        header: S.status,
        type: 'enum',
        width: 140,
        options: [
          { value: 'open', label: S.openLbl, status: 'open' },
          { value: 'mitigated', label: 'mitigated', status: 'review' },
          { value: 'cleared', label: S.cleared, status: 'active' },
        ],
      },
      { key: 'created_at', header: S.created, type: 'date', width: 150 },
    ],
    [],
  )
  const fetcher = useCallback(fetchMassRegistration, [])
  return (
    <>
      <PageHeader title={S.massReg} screenId="A18.15" />
      <DataTable<MassRegRow>
        screenId="A18.15"
        permission={PERMISSIONS.AUDIT_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <UsersRound size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
